import { useSelector } from "react-redux";
const useSideBarMenus = () => {
  const { currentUser } = useSelector((state) => state.store);
  let deliveryBusiness = "Ecommerce"
  if (currentUser?.delivery_business) {
    deliveryBusiness = currentUser?.delivery_business?.name
  }
  const data = [
    {
      icon: "BsShop",
      title: "Dashboard",
      path: "dashboard",
    },
    {
      icon: "BsBoxSeam",
      title: "Order",
      path: "order/all-orders",
      submenu: [],
      accordian: [
        {
          accordianTitle: "Order",
          accordianmenu: [
            {
              title: "All",
              path: "order/all-orders",
              icon: "MdContentPaste",
            },
            {
              title: "Pending",
              path: "order/pending-orders",
              icon: "GiSandsOfTime",
            },
            {
              title: "Accepted",
              path: "order/accepted-orders",
              icon: "MdToday",
            },
            {
              title: "Assigned",
              path: "order/assigned-orders",
              icon: "MdOutlineDeliveryDining",
            },
            {
              title: "Delivered",
              path: "order/delivered-orders",
              icon: "CiDeliveryTruck",
            },
            // {
            //   title: "Dispatch",
            //   path: "order/dispatch",
            //   icon: "BsCartCheckFill",
            // },
            {
              title: "Return",
              path: "order/return-order",
              icon: "TbTruckReturn",
            },
            {
              title: "Cancel",
              path: "order/cancel-order",
              icon: "MdOutlineCancel",
            },
            {
              title: "Replacement",
              path: "order/replacement",
              icon: "TbZoomReplace",
            },
          ],
        },
        // {
        //   accordianTitle: "Review",
        //   accordianmenu: [
        //     // {
        //     //   "title": "History",
        //     //   "path": "history/history-list",
        //     //   "icon": "RiFolderHistoryFill"
        //     // },
        //     {
        //       title: "Store",
        //       path: "order/store-reviews",
        //       icon: "CiStar",
        //     },
        //     {
        //       title: "Product",
        //       path: "order/product-reviews",
        //       icon: "CiStar",
        //     },
        //   ],
        // },
      ],
    },
    {
      icon: "GiCoins",
      title: "Earning",
      path: "earning/order",
      submenu: [
        // {
        //   "icon": "SlCalender",
        //   "title": "Current Week",
        //   "path": "earning/current-week"
        // },
        // {
        //   "icon": "VscCalendar",
        //   "title": "Current Month",
        //   "path": "earning/current-month"
        // },
        {
          icon: "AiOutlineProduct",
          title: "Earning",
          path: "earning/order",
        },
      ],
      accordian: [],
    },
    {
      icon: "TiThMenuOutline",
      title: "Menu",
      path:
        deliveryBusiness === "Ecommerce"
          ? "menu/item-list"
          : "menu/item-food-list",
      submenu: [],
      accordian: [
        {
          accordianTitle: "Menu",
          accordianmenu: [
            {
              icon: "LuBoxes",
              title: "Category",
              path: "menu/category",
            },
            deliveryBusiness === "Ecommerce"
              ? {
                icon: "CgNotes",
                title: "Item",
                path: "menu/item-list",
              }
              : {
                icon: "CgNotes",
                title: "Food Item",
                path: "menu/item-food-list",
              },
          ],
        },
        deliveryBusiness === "Ecommerce" ? null :
          {
            accordianTitle: "Modifier",
            accordianmenu: [
              {
                icon: "SiModin",
                title: "Modifier Category",
                path: "menu/modifier-group",
              },
              // {
              //   icon: "MdImportExport",
              //   title: "Import Export",
              //   path: "menu/import-data",
              // },
            ],
          },
      ],
    },
    {
      icon: "SlNotebook",
      title: "Inventory",
      path: "inventory/grv",
      submenu: [],
      accordian: [
        {
          accordianTitle: "Inventory",
          accordianmenu: [
            {
              icon: "FaSitemap",
              title: "Goods Receipt Voucher",
              path: "inventory/grv",
            },
            {
              icon: "CgNotes",
              title: "Goods Issue Voucher",
              path: "inventory/giv",
            },
          ],
        },
        {
          accordianTitle: "Report",
          accordianmenu: [
            {
              icon: "CgNotes",
              title: "Stocks On Hand Report",
              path: "inventory/stock-on-hand-report",
            },
            {
              icon: "CgNotes",
              title: "Stocks Ledger",
              path: "inventory/stock-ledger-report",
            },
          ],
        },

      ],
    },

    // {
    //   icon: "GiTakeMyMoney",
    //   title: "Funding Opportunity",
    //   path: "menu/funding-opportunity",
    //   submenu: [
    //     {
    //       icon: "GiTakeMyMoney",
    //       title: "Finance & Funds",
    //       path: "menu/funding-opportunity",
    //     },
    //     // {
    //     //   icon: "FaStore",
    //     //   title: "Create Sale",
    //     //   path: "offers/sale",
    //     // },
    //   ],
    //   accordian: [],
    // },
    {
      icon: "IoChatbubbleEllipsesOutline",
      title: "Messages",
      path: "bulkchat/chats",
      submenu: [],
      accordian: [
        {
          accordianTitle: "Messages",
          accordianmenu: [
            {
              icon: "IoChatbubbleEllipsesOutline",
              title: "Message",
              path: "bulkchat/chats",
            },
          ],
        },
      ],
    },
    {
      icon: "IoStarOutline",
      title: "Reviews",
      path: "reviews",
      submenu: [],
      accordian: [
        {
          accordianTitle: "Reviews",
          accordianmenu: [
            {
              icon: "IoStarOutline",
              title: "Reviews",
              path: "reviews",
            },
          ],
        },
      ],
    },

    {
      icon: "AiOutlineTag",
      title: "Offers",
      path: "offers/promocode",
      submenu: [

      ],
      accordian: [
        {
          accordianTitle: "Offers",
          accordianmenu: [{
            icon: "RiCoupon3Line",
            title: "Create Promo",
            path: "offers/promocode",
          },
          {
            icon: "FaStore",
            title: "Create Sale",
            path: "offers/sale",
          },]
        }
      ],
    },
    {
      icon: "RiAdvertisementLine",
      title: "Advertisement",
      path: "Promotion/advertisement-management",
      submenu: [
        {
          icon: "RiAdvertisementLine",
          title: "Advertise Management",
          path: "Promotion/advertisement-management",
        },
        // {
        //   "icon": "FaStore",
        //   "title": "Create Sale",
        //   "path": "offers/sale"
        // }
      ],
      accordian: [],
    },
    {
      icon: "SlNotebook",
      title: "Approvals",
      path: "approvals/category",
      submenu: [],
      accordian: [
        {
          accordianTitle: "Menu",
          accordianmenu: [
            {
              title: "Category",
              path: "approvals/category",
              icon: "LuBoxes",
            },
            {
              title: "Subcategory",
              path: "approvals/sub-category",
              icon: "BiCategoryAlt",
            },
            {
              title: "Item",
              path: "approvals/item",
              icon: "MdToday",
            },
          ],
        },
        {
          accordianTitle: "Offer",
          accordianmenu: [
            {
              title: "Promo-code approval",
              path: "approvals/promo-code",
              icon: "RiCoupon3Line",
            },
            {
              title: "Sale approval",
              path: "approvals/sale",
              icon: "FaStore",
            },
          ],
        },
        {
          accordianTitle: "Advertisment",
          accordianmenu: [
            {
              title: "Advertise",
              path: "approvals/advertise",
              icon: "RiAdvertisementLine",
            },
          ],
        },
        {
          accordianTitle: "Rejections",
          accordianmenu: [
            {
              title: "Category",
              path: "approvals/category-reject",
              icon: "LuBoxes",
            },
            {
              title: "Subcategory",
              path: "approvals/subcategory-reject",
              icon: "BiCategoryAlt",
            },
            {
              title: "Item",
              path: "approvals/item-reject",
              icon: "MdToday",
            },
            {
              title: "Promo Code",
              path: "approvals/promo-code-reject",
              icon: "RiCoupon3Line",
            },
            {
              title: "Sales",
              path: "approvals/sale-reject",
              icon: "AiOutlineTag",
            },
            {
              title: "Advertise",
              path: "approvals/advertise-reject",
              icon: "RiAdvertisementLine",
            },
          ],
        },
      ],
    },
    {
      icon: "IoStarOutline",
      title: "Complaints",
      path: "complaints",
      submenu: [],
      accordian: [
        {
          accordianTitle: "Complaints",
          accordianmenu: [{ icon: "IoStarOutline", title: "Complaints", path: "complaints" }],
        },
      ],
    },
  ];

  return data
}
export default useSideBarMenus;
